import { render, staticRenderFns } from "./CreateNewPassword.vue?vue&type=template&id=99536d9a&scoped=true&lang=true&"
import script from "./CreateNewPassword.vue?vue&type=script&lang=js&"
export * from "./CreateNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewPassword.vue?vue&type=style&index=0&id=99536d9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99536d9a",
  null
  
)

export default component.exports